import { combineReducers } from '@reduxjs/toolkit'
import collecting from './collecting.store'

export const rootReducer = combineReducers({
  collecting,
})
